import { useState, useEffect } from 'react';
import { getViewport, useBounds } from '../useBounds';

type Return = {
  isSmallViewport: boolean;
  isMediumViewport: boolean;
  isLargeViewport: boolean;
};

export const useViewport = (): Return => {
  const { width, height } = useBounds();

  const [viewportType, setViewportType] = useState<string>(
    getViewport().viewportType
  );

  useEffect(() => {
    setViewportType(getViewport().viewportType);
  }, [width, height]);

  return {
    isSmallViewport: viewportType === 'small',
    isMediumViewport: viewportType === 'medium',
    isLargeViewport: viewportType === 'large',
  };
};
